import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import PieceInfoTable from "../../components/piece/pieceInfoTable";
import { useDashboardContext } from "../../context/dashboardContext";
import { DownloadResponseDTO } from "../../openapi-generated-client";

export default function DashboardDownloadHistoryPage() {


    const {sessionId, appContext} = useDashboardContext();
    const {downloadController} = appContext;

    const  [data, setData] = useState<DownloadResponseDTO[]>();

    async function fetchData() {
        setData((await downloadController.getDownloads(sessionId)).data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    if(!data) return <Loader/>;

    if(data.length === 0) {
        return <p className="quotation">You didn't download any piece yet</p>;
    }
    
    return <PieceInfoTable data={data}/>;
}